function startOfDay(d) {
    const x = new Date(d);
    x.setHours(0, 0, 0, 0);
    return x;
}

function endOfDay(d) {
    const x = new Date(d);
    x.setHours(23, 59, 59, 0);
    return x;
}

function addDays(d, n) {
    const x = new Date(d);
    x.setDate(x.getDate() + n);
    return x;
}

function addMonths(d, n) {
    const x = new Date(d);
    x.setMonth(x.getMonth() + n);
    return x;
}

export const INTERVAL_PRESETS = [
    {
        id: "today",
        label: "Hoje",
        resolve: () => {
            const now = new Date();
            return { from: startOfDay(now), to: endOfDay(now) };
        },
    },
    {
        id: "last_7_days",
        label: "Últimos 7 dias",
        resolve: () => {
            const now = new Date();
            return { from: startOfDay(addDays(now, -6)), to: endOfDay(now) };
        },
    },
    {
        id: "last_4_weeks",
        label: "Últimas 4 semanas",
        resolve: () => {
            const now = new Date();
            return { from: startOfDay(addDays(now, -27)), to: endOfDay(now) };
        },
    },
    {
        id: "last_3_months",
        label: "Últimos 3 meses",
        resolve: () => {
            const now = new Date();
            return { from: startOfDay(addMonths(now, -3)), to: endOfDay(now) };
        },
    },
    {
        id: "last_6_months",
        label: "Últimos 6 meses",
        resolve: () => {
            const now = new Date();
            return { from: startOfDay(addMonths(now, -6)), to: endOfDay(now) };
        },
    },
    {
        id: "last_12_months",
        label: "Últimos 12 meses",
        resolve: () => {
            const now = new Date();
            return { from: startOfDay(addMonths(now, -12)), to: endOfDay(now) };
        },
    },
    {
        id: "month_to_date",
        label: "Mês até a data",
        resolve: () => {
            const now = new Date();
            const from = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);
            return { from, to: endOfDay(now) };
        },
    },
    {
        id: "quarter_to_date",
        label: "Trimestre até a data",
        resolve: () => {
            const now = new Date();
            const qMonth = Math.floor(now.getMonth() / 3) * 3;
            const from = new Date(now.getFullYear(), qMonth, 1, 0, 0, 0, 0);
            return { from, to: endOfDay(now) };
        },
    },
    {
        id: "year_to_date",
        label: "Ano até a data",
        resolve: () => {
            const now = new Date();
            const from = new Date(now.getFullYear(), 0, 1, 0, 0, 0, 0);
            return { from, to: endOfDay(now) };
        },
    },
    {
        id: "all_time",
        label: "Desde o início",
        resolve: () => {
            const from = new Date(2000, 0, 1, 0, 0, 0, 0);
            const to = endOfDay(new Date());
            return { from, to };
        },
    },
];

export const INTERVAL_PRESET_MAP = INTERVAL_PRESETS.reduce((acc, p) => {
    acc[p.id] = p;
    return acc;
}, {});
